import { NetworkBasePopUp } from '../NetworkBasePopUp';

export class RemoteShellPopUp extends NetworkBasePopUp<undefined> {
  protected title = ''; // not used
  protected extraDialogConfigs = {}; // not used

  protected customSetup() {
    const endpointIds: Array<string> = [];
    for (const target of this.data.targets || []) {
      const endpointId = target.specifics.endpointId;

      if (endpointId && !endpointIds.includes(endpointId)) {
        endpointIds.push(endpointId);
      }
    }

    for (const endpointId of endpointIds) {
      const pathToOpen = `/remote-shell/${endpointId}`;
      Application.lib.Navigation.openInNewTab(pathToOpen);
    }
  }

  // not used
  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    return undefined;
  }
}
